import React from 'react';

// List context, which contains all list context,
// and is added to by containers below
export const ListContext = React.createContext();

